import { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link as ScrollLink } from "react-scroll";
import logo from "../assets/vanadevrai.png"
import { Link, useNavigate } from "react-router-dom";

const navItems = [
  { label: "Home", id: "home" },
  { label: "About", id: "about" },
  { label: "Activities", id: "activities" },
  { label: "Gallery", id: "gallery" },
  { label: "Contact", id: "contact" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [openMore, setOpenMore] = useState(false);
  const navigate=useNavigate()

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* 🌿 Navbar */}
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          width: "92%",
          borderRadius: "24px",
          padding: "6px 10px",

          backdropFilter: "blur(25px) saturate(180%)",
          WebkitBackdropFilter: "blur(25px) saturate(180%)",

          background: scrolled
            ? "linear-gradient(135deg, rgba(255,255,255,0.7), rgba(209,250,229,0.6))"
            : "linear-gradient(135deg, rgba(255,255,255,0.4), rgba(187,247,208,0.3))",

          border: "1px solid rgba(255,255,255,0.4)",

          boxShadow: scrolled
            ? "0 10px 40px rgba(0,0,0,0.15)"
            : "0 8px 30px rgba(0,0,0,0.08)",

          transition: "all 0.4s ease",
          color: "#064e3b",
        }}
      >
        <Toolbar className="flex justify-between">
          {/* Logo */}
          <Typography variant="h6" fontWeight="bold">
            <div className=" flex gap-2 items-center">
              <span>
                <img alt="img" className="w-7" src={logo} />
              </span>
              <span>Vanadevrai Foundation</span>
            </div>
          </Typography>

          {/* Desktop Menu */}
          <Box className="hidden md:flex gap-6">
            {navItems.map((item) => (
              <ScrollLink
                key={item.id}
                to={item.id}
                smooth={true}
                duration={600}
                offset={-80}
                onClick={()=>{
                  if(item.label==="Home"){
                    navigate("/")
                  }
                }}
              >
                <Button
                  color="inherit"
                  className="hover:text-green-600 transition"
                >
                  {item.label}
                </Button>
              </ScrollLink>
            ))}
          </Box>

          {/* Mobile Menu Button */}
          <IconButton className="md:hidden" onClick={() => setOpen(true)}>
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* 📱 Mobile Drawer */}
      <Drawer anchor="right" open={open} onClose={() => setOpen(false)}>
        <Box
          className="w-72 h-full flex flex-col justify-between"
          sx={{
            background: "linear-gradient(to bottom, #ecfdf5, #d1fae5, #bbf7d0)",
          }}
        >
          {/* Top */}
          <div>
            <div className="flex justify-between items-center p-4">
              <Typography variant="h6">🌿 Menu</Typography>
              <IconButton onClick={() => setOpen(false)}>
                <CloseIcon />
              </IconButton>
            </div>

            <List>
              {navItems.map((item) => (
                <ScrollLink
                  key={item.id}
                  to={item.id}
                  smooth={true}
                  duration={500}
                  offset={-80}
                  onClick={() => setOpen(false)}
                >
                  <ListItem button>
                    <ListItemText primary={item.label} />
                  </ListItem>
                </ScrollLink>
              ))}

              {/* 🔽 MORE MENU */}
              <ListItem button onClick={() => setOpenMore(!openMore)}>
                <ListItemText primary="More ⌄" />
              </ListItem>

              {openMore && (
                <>
                  <ListItem
                    button
                    component={Link}
                    to="/admin/create"
                    onClick={() => setOpen(false)}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="🌿 Create Activity" />
                  </ListItem>

                  <ListItem
                    button
                    component={Link}
                    to="/admin/upload"
                    onClick={() => setOpen(false)}
                    sx={{ pl: 4 }}
                  >
                    <ListItemText primary="📸 Upload Image" />
                  </ListItem>
                </>
              )}
            </List>
          </div>

          {/* Bottom CTA */}
          <div className="p-4">
            <Button
              variant="contained"
              color="success"
              fullWidth
              className="rounded-full"
            >
              🌱 Join Us
            </Button>
          </div>
        </Box>
      </Drawer>
    </>
  );
}